<template>
  <b-modal
    id="product-details-modal"
    :visible="value"
    @hide="$emit('input', false)"
    hide-footer
    size="xl"
    :title="product ? product.name : 'Product Details'"
  >
    <div v-if="product" class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <div class="card shadow-sm mb-4">
            <div class="card-body p-0">
              <b-carousel
                id="image-carousel-product"
                v-if="product.documentUploads && product.documentUploads.length > 0"
                controls
                indicators
                background="#ababab"
                :interval="4000"
                img-width="1024"
                img-height="480"
                class="rounded"
              >
                <b-carousel-slide
                  v-for="doc in product.documentUploads"
                  :key="doc.id"
                  :img-src="`${apiBaseUrl}${doc.fileUrl}`"
                ></b-carousel-slide>
              </b-carousel>
              <div v-else class="image-placeholder d-flex align-items-center justify-content-center">
                <i class="bi bi-image-fill text-muted" title="No image available"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-5">
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <h1 class="product-title">{{ product.name }}</h1>
              <p class="text-muted lead mb-2">Category: {{ product.categoryName || '—' }}</p>
              
              <hr class="my-3">
              
              <div class="details-section">
                <h6>Product Information</h6>
                <div class="row mb-2">
                  <div class="col-5 text-muted">Total Stock:</div>
                  <div class="col-7 font-weight-bold">{{ product.stock || 0 }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5 text-muted">Purchase Price:</div>
                  <div class="col-7 font-weight-bold">{{ product.purchasePrice || '—' }}</div>
                </div>
                <div class="row mb-2">
                  <div class="col-5 text-muted">Selling Price:</div>
                  <div class="col-7 font-weight-bold">{{ product.sellingPrice || '—' }}</div>
                </div>
              </div>
              
              <hr class="my-3">

              <div class="description-section">
                <h6>Product Description</h6>
                <p class="text-secondary small">{{ product.description || 'No description available for this product.' }}</p>
              </div>

              <div class="mt-4">
                <b-button variant="success" block size="lg" class="mb-2">View All Units</b-button>
                <b-button variant="outline-secondary" block>Contact Supplier</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center py-5 text-muted">
      Loading product details...
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ProductDetailsModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      apiBaseUrl: " "
    };
  }
};
</script>

<style scoped>
.product-title {
  font-weight: 600;
}

.image-placeholder {
  width: 100%;
  height: 480px;
  background-color: #f8f9fa;
  font-size: 5rem;
  color: #dee2e6;
  border-radius: 0.25rem;
}

.card-body h6 {
  font-weight: 600;
  color: #343a40;
}
</style>